
const ARIA_INVALID = 'aria-invalid';
export const getErrorType = (validity) => {
    const { valueMissing, rangeOverflow, rangeUnderflow } = validity;
    if (valueMissing) {
        return 'required'
    }
    if (rangeOverflow || rangeUnderflow) {
        return 'invalid';
    }
    return null;
};

export const handleError = (control, errorMessage) => {
    const beaconFormField = control.parentElement;
    let slottedError = beaconFormField.querySelector('[slot="error"]');
    if (!slottedError) {
        const errorContainer = document.createElement('div');
        errorContainer.slot = 'error';
        beaconFormField?.append(errorContainer);
        slottedError = errorContainer;
    }
    slottedError.innerText = errorMessage;
};
export const getErrorMessage = (errorMap) => {
    for (const key in errorMap) {
        return errorMap[key]
    }
    return null
};

export const validateControl = (control, state) => {
    const validity = control.validity;
    let errorType = getErrorType(validity);
    const errorMap = {
        'from-date-beacon': 'Select a valid date',
        'to-date-beacon': 'Select a valid date'
    };

    // Additional validation for date comparison
    const fromDateControl = document.getElementById('from-date-beacon');
    const toDateControl = document.getElementById('to-date-beacon');
    if (fromDateControl && toDateControl) {
        const fromDateValue = new Date(fromDateControl.value);
        const toDateValue = new Date(toDateControl.value);
        if (fromDateValue > toDateValue) {
            errorType = 'invalid';
            control.setAttribute(ARIA_INVALID, 'true');
        }
    }

    if (errorType === 'invalid') {
        state.showInvalidDatemessage = true;
        return state.showInvalidDatemessage;
    }

    if (errorType === 'required' && state.showInvalidDatemessage !== true) {
        const errorMessage = getErrorMessage(errorMap);
        handleError(control, errorMessage);
        control.setAttribute(ARIA_INVALID, 'true');
    }
    return state.showInvalidDatemessage;
};


export const processControl = (control, showInvalidDatemessage) => {
    if (!(control instanceof HTMLInputElement)) {
        return;
    }

    try {
        control.checkValidity();
        validateControl(control, showInvalidDatemessage);
    } catch (error) {
        console.error(error, control);
    }
};

export const clearErrors = (form) => {
    const { elements } = form;
    Array.from(elements).forEach((control) => {
        if (control instanceof HTMLInputElement) {
            removeError(control);
            control.setAttribute(ARIA_INVALID, 'false');
        }
    });
};

export const removeError = (control) => {
    const beaconFormField = control.parentElement;
    const slottedError = beaconFormField.querySelector('[slot="error"]');
    if (slottedError) {
        slottedError.remove();
    }
}

export const handleDateFormSubmit = (form, callback) => {
    if (!(form instanceof HTMLFormElement)) {
        return [];
    }
    const state = { showInvalidDatemessage: false };

    clearErrors(form);

    const { elements } = form;
    Array.from(elements).forEach((control) => {
        processControl(control, state);
    });

    if (typeof callback === 'function') {
        callback(state.showInvalidDatemessage);
    }
    return []
};
